import { render } from "./routerViewEditAdmin.vue?vue&type=template&id=2b673cca"
import script from "./routerViewEditAdmin.vue?vue&type=script&lang=js"
export * from "./routerViewEditAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__